import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import axios from 'axios';
import {StorageNames, StorageService} from "src/app/services/storage.service";
import {ApiClientService} from './apiClient.service';
import {GlobalService} from './global.service';

@Injectable({
    providedIn: 'root'
})

export class RemoteDataService {
    public fixersAddress: string;
    public globalFixersAddress: string;
    public globalFixers: string;
    public validatorFixersAddress: string;
    public validatorFixers: string;
    public accessibilityFixers: string;
    public mappings: string;
    public staticAddress: string;
    public isOnPremise: boolean;
    public locallization: string = null;

    constructor(private translate: TranslateService, private globalService: GlobalService, private apiClient: ApiClientService, private storageService: StorageService) {
    }

    public setFixersAddress(address) {
        return this.fixersAddress = address;
    }

    public setStaticAddress(address) {
        return this.staticAddress = address;
    }

    public setIsOnPremise(state: boolean) {
        return this.isOnPremise = state;
    }

    public setGlobalFixersAddress(address) {
        return this.globalFixersAddress = address;
    }

    public setValidatorFixersAddress(address) {
        return this.validatorFixersAddress = address;
    }

    public async getAll() {
        const validatorFixers = await this.getValidatorFixers();
        const accessibilityFixers = await this.getAccessibilityFixers();
        const globalFixers = await this.getGlobalFixers();
        const localization = await this.getLocalization();
        const mapping = await this.getMapping();

        return {
            accessibilityFixers,
            globalFixers,
            mapping,
            localization,
            validatorFixers
        }
    }

    public async getStatement() {
        try {
            const url = this.globalService.fullUrl;
            const lang = this.globalService.language;

            let statement = this.isOnPremise
                ? await this.apiClient.getStaticFiles(`${this.staticAddress}/content/${lang}.html`)
                : await this.apiClient.get(`/statement`, {url, lang});

            if (statement.error) {
                statement = "";
            }

            return statement;
        } catch (error) {
            return "";
        }
    }


    public async sendLog(url: string, logMsg: string) {
        await this.apiClient.post("/logger", {url, msg: logMsg});
    }

    public async getLangScript(url: string) {
        const langScript = this.isOnPremise ? await this.apiClient.getStaticFiles(`${this.staticAddress}/content/language.js`) :
            await this.apiClient.get(`/lang/script?url=${url}`);
        return langScript;
    }

    private async getLocalization() {
        if (!this.locallization) {
            try {
                const lang = this.globalService.language;

                let locallization = this.isOnPremise
                    ? await this.apiClient.getStaticFiles(`${this.staticAddress}/content/${lang}.json`)
                    : await this.apiClient.get(`/lang`, {
                        url: this.globalService.fullUrl,
                        lang: this.globalService.language
                    });

                if (locallization.error) {
                    locallization = "{}";
                }

                this.locallization = locallization;
            } catch (error) {
                this.locallization = "{}";
            }

        }
        return this.locallization
    }

    private async getGlobalFixers() {
        if (!this.globalFixers) {

            let globalFixers = await this.apiClient.getStaticFiles(this.globalFixersAddress);

            if (globalFixers.error) {
                globalFixers = "";
            }
            ;

            this.globalFixers = globalFixers;
        }
        return this.globalFixers;
    }

    private async getAccessibilityFixers() {
        if (!this.accessibilityFixers) {
            let accessibilityFixer = await this.apiClient.getStaticFiles(this.fixersAddress);

            if (accessibilityFixer.error) {
                accessibilityFixer = "";
            }

            this.accessibilityFixers = accessibilityFixer;
        }
        return this.accessibilityFixers;
    }

    private async getValidatorFixers() {
        if (!this.validatorFixers) {
            let validatorFixer = await this.apiClient.getStaticFiles(this.validatorFixersAddress);

            if (validatorFixer.error) {
                validatorFixer = "";
            }

            this.validatorFixers = validatorFixer;
        }
        return this.validatorFixers;
    }

    private async getMapping() {
        if (!this.mappings) {
            let mappings = "";
            const profiles = JSON.parse(this.storageService.get(StorageNames.Settings));
            
            if(profiles) {
                const profilesNames = profiles && profiles.profiles.map(profile => profile.id);

                mappings = this.isOnPremise
                    ? await this.apiClient.getStaticFiles(`${this.staticAddress}/content/scripts.js`)
                    : await this.apiClient.get(`/scripts`, {
                        url: this.globalService.fullUrl,
                        profiles: profilesNames ? profilesNames.join(",") : null
                    });
            }
            this.mappings = mappings;
        }
        return this.mappings;
    }

}